export default {
  list: '/portal/units/',
  entity: '/portal/units/:id/',
  tabHash: ['property', 'integrations'],
}
